import React from "react";
import classNames from "classnames";
import styles from "./Calendar.module.css";
import { BLOCK_SIZE, useConfig } from "../hooks/useConfig";
import { createArrayWithValues, getRandomColor } from "../uitls";

export const Block = ({ n }) => {
  const { weeksDiff, weeksToLive } = useConfig();
  // 10 x 26
  return (
    <div className={styles.blockWrapper} key={n}>
      {createArrayWithValues(BLOCK_SIZE, n === 1 ? 0 : n * BLOCK_SIZE).map(
        (n2) => {
          if (n2 > weeksToLive) {
            return null;
          }
          return (
            <div
              className={classNames(
                styles.block,
                n2 <= weeksDiff && styles.blockFilled
              )}
              style={{
                background: n2 <= weeksDiff ? getRandomColor() : "#fff",
              }}
              key={n2}
            ></div>
          );
        }
      )}
    </div>
  );
};
